import React from 'react';
import { Card, CardContent, Typography, Box } from '@mui/material';

const cardSx = {
    width: 360,
    height: 240,
};

const SavingsTimeCard: React.FC = () => {
    return (
        <Card sx={cardSx}>
            <CardContent>
                <Box display="flex" justifyContent="space-between" alignItems="center">
                    <Typography variant="h6">Savings in time</Typography>
                </Box>
            </CardContent>
        </Card>
    );
};

export default SavingsTimeCard;
